import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, ReactNode } from 'react';
import { cx } from 'class-variance-authority';
import FormLabel from '../form/FormLabel';
const VARIANTS = {
  spacing: 'mb-6',
  no_spacing: '',
  flexSpacing: 'flex flex-col gap-3'
} as const satisfies Record<string, string>;
type FormGroupProps = Pick<React.ComponentProps<typeof FormLabel>, 'required'> & {
  description?: ReactNode;
  labelSize?: ComponentProps<typeof FormLabel>['size'];
  /** @default 'spacing' */
  variant?: keyof typeof VARIANTS;
  className?: string;
  children: ReactNode;
  /** @default 'text-blue-500' */
  labelTextColor?: string;
  classNameLabel?: ComponentProps<typeof FormLabel>['className'];
  htmlFor?: React.ComponentProps<typeof FormLabel>['htmlFor'];
  label?: React.ReactNode;
};
export default function FormGroup(t0) {
  const $ = _c(21);
  const {
    label,
    description,
    labelSize,
    htmlFor,
    variant: t1,
    children,
    className,
    labelTextColor: t2,
    classNameLabel,
    required
  } = t0;
  const variant = t1 === undefined ? "spacing" : t1;
  const labelTextColor = t2 === undefined ? "text-blue-500" : t2;
  const DescriptionWrapper = typeof description === "string" ? "p" : "div";
  const t3 = VARIANTS[variant];
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = cx("w-full", [t3, className]);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== classNameLabel || $[4] !== htmlFor || $[5] !== label || $[6] !== labelSize || $[7] !== labelTextColor || $[8] !== required) {
    t5 = label && <FormLabel htmlFor={htmlFor} size={labelSize} className={cx(labelTextColor, classNameLabel)} required={required}>{label}</FormLabel>;
    $[3] = classNameLabel;
    $[4] = htmlFor;
    $[5] = label;
    $[6] = labelSize;
    $[7] = labelTextColor;
    $[8] = required;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== DescriptionWrapper || $[11] !== description) {
    t6 = description && <DescriptionWrapper className="text-sm font-medium leading-5 text-blue-500">{description}</DescriptionWrapper>;
    $[10] = DescriptionWrapper;
    $[11] = description;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cx("relative my-1 sm:mt-2");
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== children) {
    t8 = <div className={t7}>{children}</div>;
    $[14] = children;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t8) {
    t9 = <div data-form-field="" className={t4}>{t5}{t6}{t8}</div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}